import React, { useState, useContext,useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import {
  Box,
  IconButton,
  Input,
  Paper,
  SvgIcon,
  makeStyles
} from '@material-ui/core';
import { Send as SendIcon } from 'react-feather';
import { useParams } from 'react-router';
import { WebSocketContext } from 'src/WebSocket';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    padding: '13px 65px 13px 10px'
  },
  fileInput: {
    display: 'none'
  },
  input: {
    backgroundColor: 'white',
    borderRadius: '20px',
    color: 'black',
    border: '0.5px solid lightgray;'
  }
}));

function MessageAdd({ className, config, disabled, onAdd, ...rest }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { botId, userId } = useParams();
  const [text, settext] = useState('');
  const { socket, reconnectSocket } = useContext(WebSocketContext);

  const handleChange = event => {
    event.persist();
    settext(event.target.value);
  };

  useEffect(() => {
    socket.on('connect', message => {
      enqueueSnackbar('Reconnected successfully!', { variant: 'success', anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          } });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    });

    return () => {
      socket.off('message');
    };
  }, [socket]);

  const handleSend = async () => {
    try {
      if (!text || !userId) {
        return;
      }

      if (!socket || !socket.connected) {
        enqueueSnackbar('Reconnecting...', { variant: 'info', anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          } });
        await reconnectSocket();
        if (!socket || !socket.connected) {
          enqueueSnackbar('Failed to reconnect. Please try again later.', { variant: 'error', anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          } });
          return;
        }
        enqueueSnackbar('Reconnected successfully!', { variant: 'success', anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          } });
      }

      await onAdd(botId, text);
      settext('');
    } catch (error) {
      enqueueSnackbar('Error sending message!', {
        variant: 'error'
      });
    }
  };

  const handleKeyUp = event => {
    if (event.keyCode === 13) {
      handleSend();
    }
  };

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Paper className={classes.input} component={Box} flexGrow={1} p={1}>
        <Input
          disableUnderline
          fullWidth
          value={text}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
        />
      </Paper>
      <span style={{ color: config.bgColor }}>
        <IconButton
          color='inherit'
          disabled={!text || disabled}
          onClick={handleSend}
        >
          <SvgIcon fontSize='small'>
            <SendIcon />
          </SvgIcon>
        </IconButton>
      </span>
    </div>
  );
}

MessageAdd.propTypes = {
  className: PropTypes.string,
  thread: PropTypes.object,
  disabled: PropTypes.bool,
  onAdd: PropTypes.func
};

MessageAdd.defaultProps = {
  className: '',
  disabled: false,
  onAdd: () => {}
};

export default MessageAdd;